export function convertNullValuesToUndefined(obj: any): any {
  if (obj === null) {
    return undefined;
  }
  if (typeof obj !== 'object') {
    return obj;
  }
  if (obj instanceof Array) {
    return obj.map(convertNullValuesToUndefined);
  }

  return Object.keys(obj).reduce(
    (result, key) => ({
      ...result,
      [key]: convertNullValuesToUndefined(obj[key]),
    }),
    {}
  );
}
